import * as React from "react";
import {Box, Typography} from "@mui/material";

import {NotAllowedBlock} from "@components";


export default function customerColumn() {
    return [{
        name: 'customerName', label: 'Customer Name',
        options: {
            display: 'excluded'
        }
    }, {
        name: 'customerID', label: 'Customer',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRenderLite: (value, row) => {
                return <Box display="flex" flexDirection="column">
                    {!value && <NotAllowedBlock />}
                    {!!value && <Box>
                        <Box>{row?.customerName}</Box>
                        <Typography variant='subtitle2'>
                            {'Customer ID : ' + value}
                        </Typography>
                    </Box>}
                </Box>
            }
        }
    }]
}